/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Grid, IconButton, Typography, TextField, Box, Menu, MenuItem, DialogActions, Button, Stack } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, StaticDatePicker } from '@mui/x-date-pickers';
import { IoClose } from 'react-icons/io5';
// import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import styled from 'styled-components';
import { LanguageContext } from '../../../../../../../../libs/Context';
import { catchErr } from '../../../../../../../../libs/HelperContent';
import { toast } from 'react-toastify';
import { createFeedContext } from '../..';
import Loading from '../../../../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import dayjs from 'dayjs';

const ScheduleLaterPopup = ({ openPop, handleClose }) =>
{
	const { createFeed, setCreateFeed } = useContext(createFeedContext);
	const [ selectedDate, setSelectedDate ] = useState<any>(createFeed?.scheduledAt ? new Date(createFeed?.scheduledAt) : new Date());

	const [ slctdTimeFrmt, setSlctdTimeFrmt ] = useState<any>({
		hrs    : String((new Date(selectedDate)?.getHours() % 12) || 12).padStart(2, '0'),
		mints  : new Date(selectedDate)?.getMinutes(),
		format : new Date(selectedDate)?.getHours() < 12 ? 'AM' : 'PM'
	});
	const { language } = useContext(LanguageContext);
	const [ anchorEl, setAnchorEl ] = useState(null);
	const [ menuType, setMenuType ] = useState('');
	const [ loading, setLoading ] = useState<boolean>(false);

	// Check if the currently selected time is valid
	const isTimeValid = useCallback(() =>
	{
		try
		{
			// Convert 12-hour format to 24-hour format
			let hrs = Number(slctdTimeFrmt?.hrs);
			const isPM = slctdTimeFrmt?.format === 'PM';

			if (hrs === 12)
			{
				hrs = isPM ? 12 : 0;
			}
			else if (isPM)
			{
				hrs += 12;
			}

			// Create the scheduled date/time
			const scheduledDateTime = new Date(selectedDate);

			scheduledDateTime.setHours(hrs, Number(slctdTimeFrmt?.mints), 0, 0);

			// Get current date/time with buffer
			const currentDateTime = new Date();
			const bufferTime = new Date(currentDateTime.getTime() + 300000); // 5 minutes buffer

			return scheduledDateTime > bufferTime;
		}
		catch (error)
		{
			return false;
		}
	}, [ selectedDate, slctdTimeFrmt ]);

	const handleDateChange = (newDate) =>
	{
		setSelectedDate(new Date(newDate)?.setHours(0, 0, 0, 0));
	};

	const handleTimeChange = useCallback((key, value) =>
	{
		setSlctdTimeFrmt((prev) => ({ ...prev, [key]: value }));
	}, [ slctdTimeFrmt ]);

	const handleClick = (event, type) =>
	{
		setAnchorEl(event.currentTarget);
		setMenuType(type);
	};

	const handleCloseMenu = () =>
	{
		setAnchorEl(null);
		setMenuType('');
	};

	const renderMenuItems = (type) =>
	{
		const createMenuItems = (key, length) =>
		{
			const currentDate = new Date();
			const selectedDateObj = new Date(selectedDate);
			const isToday = selectedDateObj.toDateString() === currentDate.toDateString();

			return Array.from({ length }, (_, index) =>
			{
				let isDisabled = false;

				// Disable past times if selected date is today
				if (isToday)
				{
					if (key === 'hrs')
					{
						const currentHour = currentDate.getHours();
						const isPM = slctdTimeFrmt?.format === 'PM';

						// Convert this hour option (12-hour) + the selected AM/PM to 24-hour
						// before comparing, so e.g. 8 PM isn't disabled just because it's 9 AM now.
						let hour24 = index;

						if (index === 12)
						{
							hour24 = isPM ? 12 : 0;
						}
						else if (isPM)
						{
							hour24 = index + 12;
						}

						// Disable only hours strictly before the current hour; the current hour
						// stays enabled and its past minutes are handled in the 'mints' branch below.
						isDisabled = hour24 < currentHour;
					}
					else if (key === 'mints')
					{
						const currentHour = currentDate.getHours();
						const currentMinute = currentDate.getMinutes();
						const selectedHour = Number(slctdTimeFrmt?.hrs);
						const isPM = slctdTimeFrmt?.format === 'PM';

						// Convert selected hour to 24-hour format for comparison
						let selectedHour24 = selectedHour;

						if (selectedHour === 12)
						{
							selectedHour24 = isPM ? 12 : 0;
						}
						else if (isPM)
						{
							selectedHour24 += 12;
						}

						// If selected hour is current hour, disable past minutes
						if (selectedHour24 === currentHour)
						{
							isDisabled = index <= currentMinute;
						}
					}
				}

				return (
					<MenuItem
						disabled={isDisabled}
						selected={slctdTimeFrmt[key] === (index >= 10 ? index : String(index).padStart(2, '0'))}
						key={index}
						onClick={() =>
						{
							if (!isDisabled)
							{
								handleCloseMenu();
								handleTimeChange(key, index >= 10 ? index : String(index).padStart(2, '0'));
							}
						}}
					>
						{index >= 10 ? index : String(index).padStart(2, '0')}
					</MenuItem>
				);
			});
		};

		switch (type)
		{
			case 'hrs':
				return createMenuItems('hrs', 13);
			case 'mints':
				return createMenuItems('mints', 60);
			case 'format':
				return [ 'AM', 'PM' ].map((period) => (
					<MenuItem
						key={period}
						selected={slctdTimeFrmt?.format === period}
						onClick={() =>
						{
							handleTimeChange('format', period);
							handleCloseMenu();
						}}
					>
						{period}
					</MenuItem>
				));
			default:
				return null;
		}
	};
	const handleMonthChange = (drctn) =>
	{
		const newDate:any = new Date(selectedDate);

		if (drctn === 'prev')
		{
			newDate.setMonth(newDate.getMonth() - 1);
		}
		else if (drctn === 'next')
		{
			newDate.setMonth(newDate.getMonth() + 1);
		}

		setSelectedDate(newDate?.setHours(0, 0, 0, 0));
	};

	const handleSave = () =>
	{
		try
		{
			setLoading(true);

			// Convert 12-hour format to 24-hour format
			let hrs = Number(slctdTimeFrmt?.hrs);
			const isPM = slctdTimeFrmt?.format === 'PM';

			if (hrs === 12)
			{
				hrs = isPM ? 12 : 0;
			}
			else if (isPM)
			{
				hrs += 12;
			}

			// Create the scheduled date/time
			const scheduledDateTime = new Date(selectedDate);

			scheduledDateTime.setHours(hrs, Number(slctdTimeFrmt?.mints), 0, 0);

			// Get current date/time
			const currentDateTime = new Date();

			// Add a 5-minute buffer to prevent scheduling exactly at current time
			const bufferTime = new Date(currentDateTime.getTime() + 300000); // 5 minutes buffer

			console.log('🕐 Time Validation Debug:', {
				scheduledTime  : scheduledDateTime.toISOString(),
				currentTime    : currentDateTime.toISOString(),
				bufferTime     : bufferTime.toISOString(),
				isValid        : scheduledDateTime > bufferTime,
				timeDifference : scheduledDateTime.getTime() - currentDateTime.getTime()
			});

			// Validate that scheduled time is greater than current time (with buffer)
			if (scheduledDateTime <= bufferTime)
			{
				toast.error(language.scheduledTimeShouldBeMoreThanCurrentTime || 'Scheduled time must be greater than current time', {
					position  : toast.POSITION.TOP_RIGHT,
					className : 'toast-message'
				});

				return; // Exit early if validation fails
			}

			// If validation passes, save the scheduled time
			const isOccasionValid = createFeed?.occasion && Object.keys(createFeed?.occasion).length > 0;

			setCreateFeed((prev) => ({
				...prev,
				...(isOccasionValid ? { ...prev, scheduledAt: scheduledDateTime.getTime() } : { scheduledAt: scheduledDateTime.getTime() })
			}));

			handleClose();
		}
		catch (err)
		{
			catchErr(err);
			console.error('Error scheduling feed:', err);
			toast.error(language?.errorSchedulingFeed || 'Error scheduling feed. Please try again.', {
				position  : toast.POSITION.TOP_RIGHT,
				className : 'toast-message'
			});
		}
		finally
		{
			setLoading(false);
		}
	};

	// const disablePstMnth = new Date(selectedDate)?.getFullYear() === new Date().getFullYear() && new Date(selectedDate)?.getMonth() === new Date().getMonth();

	const StyledStaticDatePicker = styled(StaticDatePicker)(({ theme }) => ({
		'& .MuiPickerStaticWrapper-content' : {
			borderRadius : 'var(--pixel20)'
		}
	}));

	return (
		<Dialog open={openPop} onClose={handleClose} maxWidth='xs' fullWidth>
			<DialogTitle>
				{loading && <Loading />}
				<Grid container alignItems='center'>
					<Grid item xs>
						<Typography fontSize={'var(--pixel20)'} fontWeight='var(--font500)'>{language?.schedulelater}</Typography>
					</Grid>
					<Grid item>
						<IoClose style={{ cursor: 'pointer' }} onClick={handleClose} />
					</Grid>
				</Grid>
			</DialogTitle>
			<DialogContent sx={{ padding: '0px 20px' }}>
				<Grid container direction='column' my='var(--pixel8)'>
					<Grid xs={12} item sx={{
						borderRadius : 'var(--pixel12)',
						boxShadow    : '8px 3px 22px 10px rgba(150, 150, 150, 0.11)'
					}}
					>
						<LocalizationProvider dateAdapter={AdapterDateFns}>
							<StyledStaticDatePicker
								displayStaticWrapperAs='desktop'
								// value={selectedDate}
								value={dayjs(selectedDate)}
								maxDate={dayjs().add(6, 'month')}
								disablePast
								className='yearbutton'
								onChange={handleDateChange}
								renderInput={(params) => <TextField {...params} />}
								// components={{
								// 	LeftArrowButton : () => (
								// 		<IconButton
								// 			disabled={disablePstMnth}
								// 			onClick={() => handleMonthChange('prev')}
								// 		>
								// 			<MdKeyboardArrowLeft />
								// 		</IconButton>
								// 	),
								// 	RightArrowButton : () => (
								// 		<IconButton onClick={() => handleMonthChange('next')}>
								// 			<MdKeyboardArrowRight />
								// 		</IconButton>
								// 	)
								// }}
							/>
						</LocalizationProvider>
					</Grid>
					<Grid item xs={12} display={'flex'} pt='var(--pixel16)' flexDirection={'row'} justifyContent='center' alignItems='center'>
						{[ 'hrs', 'mints', 'format' ]?.map((key) =>
							(
								<Grid item key={`id-${key}`} px='var(--pixel8)'>
									<Box
										width='72px'
										height='50px'
										sx={{ backgroundColor: '#E9F6F9', borderRadius: 'var(--pixel8)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
									>
										<Typography variant='body1' ml={1}>
											{slctdTimeFrmt[key] || '00'}
										</Typography>
										<IconButton sx={{ padding: '8px 4px' }}
											onClick={(event) => handleClick(event, key)}
										>
											<ArrowDropDownIcon />
										</IconButton>
									</Box>
									<Menu
										anchorEl={anchorEl}
										open={Boolean(anchorEl) && menuType === key}
										onClose={handleCloseMenu}
										PaperProps={{
											style : {
												maxHeight : 250
											}
										}}
									>
										{renderMenuItems(key)}
									</Menu>
								</Grid>
							)
						)}
					</Grid>

					{/* Time validation indicator */}
					<Grid item xs={12} display='flex' justifyContent='center' pt='var(--pixel8)'>
						<Typography
							variant='body2'
							sx={{
								color      : isTimeValid() ? 'var(--primaryColor)' : 'var(--redColor)',
								fontSize   : 'var(--pixel12)',
								fontWeight : 'var(--font500)'
							}}
						>
							{isTimeValid()
								? (language?.timeValid || '✅ Time is valid for scheduling')
								: (language?.timeInvalid || '⚠️ Selected time must be at least 5 minutes ahead of current time')
							}
						</Typography>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Stack direction={'row'} spacing={2} px='var(--pixel16)' pb='var(--pixel8)'>
					<Button variant='outlined' onClick={handleClose}>{language?.cancel}</Button>
					<Button
						variant='contained'
						onClick={handleSave}
						disabled={!isTimeValid() || loading}
						sx={{
							color   : 'var(--whiteColor)',
							opacity : (!isTimeValid() || loading) ? 0.6 : 1
						}}
					>
						{loading ? (language?.saving || 'Saving...') : (language?.save || 'Save')}
					</Button>
				</Stack>
			</DialogActions>
		</Dialog>
	);
};

export default ScheduleLaterPopup;
